import { Swiper, Navigation } from 'swiper'
import { symbols } from './constants'

import {
  byClass,
  isMobile,
  getQueryString
} from './utils'

function initWearImg () {
  const mySymbols = getMySymbols()
  const swiperWrapper = byClass('swiper-wrapper')
  for (const mySymbol of mySymbols) {
    swiperWrapper.appendChild(createSymbolEl(mySymbol))
  }
}

function getMySymbols() {
  let mySymbols = []
  // 获取与工作年限最相符的 symbols
  let yearCount = parseInt(getQueryString('year') || 20)
  for (let i = yearCount; i >= 0; i--) {
    if (symbols[i]) {
      mySymbols = symbols[i]
      break
    }
  }
  // 工作年限小于 5 的，只显示一个 pin
  if (yearCount < 5) {
    mySymbols = [mySymbols[3]]
  }
  return mySymbols
}

function getWearItImages() {
  return getMySymbols().reduce((result, mySymbol) => {
    result.push(mySymbol.front)
    result.push(mySymbol.back)
    return result
  }, [])
}

function createSymbolEl (mySymbol) {
  const symbolEl = document.createElement('div')
  symbolEl.classList.add('swiper-slide')
  // 翻转卡片
  const flipCard = document.createElement('div')
  flipCard.classList.add('flip-card')
  // 翻转图标
  const rotateIcon = document.createElement('img')
  rotateIcon.classList.add('rotate-icon')
  rotateIcon.src = require('../img/icon-rotate.png')
  // 正面图片
  const frontDivEl = document.createElement('div')
  const frontImgEl = document.createElement('img')
  frontDivEl.classList.add('front-img')
  frontImgEl.src = mySymbol.front
  frontDivEl.appendChild(frontImgEl)
  frontDivEl.appendChild(rotateIcon.cloneNode())
  // 背面图片
  const backDivEl = document.createElement('div')
  const backImgEl = document.createElement('img')
  backDivEl.classList.add('back-img')
  backImgEl.src = mySymbol.back
  backDivEl.appendChild(backImgEl)
  backDivEl.appendChild(rotateIcon.cloneNode())
  // 标签文字
  const spanEl = document.createElement('span')
  spanEl.innerText = mySymbol.name
  flipCard.appendChild(frontDivEl)
  flipCard.appendChild(backDivEl)
  symbolEl.appendChild(flipCard)
  symbolEl.appendChild(spanEl)
  return symbolEl
}

function initSwiper () {
  Swiper.use([Navigation])
  new Swiper('.swiper-container', {
    slidesPerView: isMobile() ? 3 : 6,
    spaceBetween: 30,
    centeredSlides: true,
    loop: false,
    initialSlide: 2,
    grabCursor: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    on: {
      init,
      setTranslate,
      setTransition,
      slideChange,
      click
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  })
}


function init (swiper) {
  for (let i = 0; i < swiper.slides.length; i++) {
    const slide = swiper.slides.eq(i)
    if (i === swiper.activeIndex) {
      // If is not mobile, flip the active card when hovering.
      !isMobile() && subscribeMouseEventOfSlide(slide)
    }
  }
}

/**
 * Swiper 左右滑动时的缩放效果
 * 为了实现滑动跟手，无法通过纯 CSS 实现
 */
function setTranslate (swiper, translate) {
  const slides = swiper.slides
  for (let i = 0; i < slides.length; i++) {
    const slide = slides.eq(i)
    if (slide.hasClass('swiper-slide-visible')) {
      const progress = slides[i].progress
      const scale = calcSwiperScale(progress)
      slide.children('.flip-card').transform(`scale(${scale})`)
    }
  }
}

function calcSwiperScale (progress) {
  let scale
  progress = Math.abs(progress)
  if (progress <= 1) {
    scale = 1.2 - progress * 0.5
  } else {
    scale = 1.2 - (progress * 0.2 + 0.3)
  }
  if (scale < 0) scale = 0
  return scale.toFixed(2)
}

function setTransition (swiper, transition) {
  for (let i = 0; i < swiper.slides.length; i++) {
    const slide = swiper.slides.eq(i)
    slide.transition(transition)
  }
}

function slideChange (swiper) {
  for (let i = 0; i < swiper.slides.length; i++) {
    const slide = swiper.slides.eq(i)
    if (i === swiper.activeIndex) {
      // If is not mobile, flip the active card when hovering.
      !isMobile() && subscribeMouseEventOfSlide(slide)
    } else {
      slide.removeClass('flipped')
      // If is not mobile, DO NOT flip the inactive cards when hovering.
      !isMobile() && unsubscribeMouseEventOfSlide(slide)
    }
  }
}

function click (swiper, event) {
  const target = swiper.clickedSlide
  if (target && target.classList.contains('swiper-slide-active')) {
    // Only flip the card by clicking on mobile.
    isMobile() && target.classList.toggle('flipped')
  } else if (target) {
    swiper.slideTo(swiper.clickedIndex)
    // Only flip the card after been activated on mobile.
    isMobile() && setTimeout(() => {
      target.classList.toggle('flipped')
    }, 300)
  }
}

function subscribeMouseEventOfSlide(slide) {
  slide.on('mouseenter', () => slide.addClass('flipped'))
  slide.on('mouseleave', () => slide.removeClass('flipped'))
}

function unsubscribeMouseEventOfSlide(slide) {
  slide.off('mouseenter')
  slide.off('mouseleave')
}

export {
  initWearImg,
  initSwiper,
  getWearItImages
}
